import React, { Fragment, useState, useEffect } from "react";
import PropTypes from "prop-types";
import LoadingDots from "../LoadingDots/LoadingDots";
import useFetchOnMount from "../hooks/useFetchOnMount/useFetchOnMount";
import Pagination from "../Pagination";

/**
 * Component Constants
 */
const pageLimit = 40;

/**
 * Generic Utility functions
 *
 * TODO: Move this to the utils functions files where appropriate
 */

/**
 * Function to sort alphabetically an array of objects by some specific key.
 *
 * @param {String} property Key of the object to sort.
 */
const dynamicAlphaSort = property => {
  var sortOrder = 1;

  if (property[0] === "-") {
    sortOrder = -1;
    property = property.substr(1);
  }

  return function(a, b) {
    if (sortOrder == -1) {
      return b[property].localeCompare(a[property]);
    } else {
      return a[property].localeCompare(b[property]);
    }
  };
};

/**
 * Returns an array with arrays of the given size.
 *
 * @param arr {Array} array to split
 * @param size {Integer} Size of every group
 */
const chunkArray = (arr, size) => {
  let index = 0;
  let arrayLength = arr.length;
  let tempArray = [];

  for (index = 0; index < arrayLength; index += size) {
    let myChunk = arr.slice(index, index + size);
    // Do something if you want with the group
    tempArray.push(myChunk);
  }

  return tempArray;
};

/**
 * SchoolsList Component
 */
const SchoolsList = ({ api }) => {
  const [fetching, setFetching] = useState(true);
  const [filter, setFilter] = useState(false);
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const [schools, setSchools] = useState(false);
  const [columns, setColumns] = useState(false);
  const [error, setError] = useState(false);

  const alphabet = "abcdefghijklmnopqrstuvwxyz".split("");

  const fetchSchoolData = async () => {
    setFetching(true);
    try {
      const { results } = await api.call('schemas', 'searchResources', [1, filter || "", 1, "*", "", false, false, false, "mixed"]);
      setSchools(results);
    } catch (error) {
      console.log(error);
      setError(error);
      setFetching(false);
    }
    setFetching(false);
  };

  useFetchOnMount(fetchSchoolData);

  const filteredSchools = () =>
    schools.filter(s => s.resourceName.charAt(0).toLowerCase() === filter);

  useEffect(() => {
    if (Array.isArray(schools)) {
      let items = schools;
      if (filter) {
        items = filteredSchools();
      }
      setPageCount(items.length);
      const pageOffsetStart = (page - 1) * pageLimit;
      const pageOffsetEnd = page * pageLimit;
      setColumns(chunkArray(items.slice(pageOffsetStart, pageOffsetEnd), 10));
    }
  }, [page, schools, filter]);

  return fetching ? (
    <LoadingDots spinnerClass="bg-primary" />
  ) : error ? (
    <div>
      Something went Wrong!
      <br />
      {JSON.stringify(error)}
    </div>
  ) : (
    <Fragment>
      <div className="container px-0 px-md-2" id="schools-list-container">
        <h2 className="h4 text-center text-primary pb-2">
          <strong>
            <strong>Want to view a School's Profile?</strong>
          </strong>
        </h2>
        <h4 className="h6 h5-md text-center pb-4">
          Click the school name below.
        </h4>
        <div className="d-flex flex-row align-items-center justify-content-center flex-wrap">
          <div
            onClick={() => {
              setFilter(false);
              setPage(1);
            }}
            className={`btn btn-sm ${
              !filter ? "btn-light text-primary border" : "btn-text"
            } rounded-0`}
          >
            All Solar Schools
          </div>
          {alphabet.map((letter, index) => (
            <div
              key={index}
              onClick={() => {
                setFilter(letter);
                setPage(1);
              }}
              className={`btn btn-sm ${
                filter === letter ? "btn-light text-primary border" : "btn-text"
              } rounded-0`}
            >
              {letter.toUpperCase()}
            </div>
          ))}
        </div>
        <div className="d-flex flex-row justify-content-center flex-wrap">
          {columns ? (
            columns.map((items, key) => (
              <div
                key={key}
                className={`col-12 col-sm-6 col-lg-3 flex-grow-1 p-3 flex-column ${
                  items.length > 6
                    ? "justify-content-between"
                    : "justify-content-start"
                }`}
                // style={{ maxWidth: "100%" }}
              >
                <div
                  className={`border-bottom-primary ${
                    key == 0 ? "text-primary" : "text-white"
                  }`}
                >
                  {items[0].resourceName.charAt(0).toUpperCase()}
                </div>
                {items.map((school, index) => (
                  <div key={index}>
                    {index > 1 &&
                    items[index - 1].resourceName
                      .charAt(0)
                      .toUpperCase() !==
                      school.resourceName.charAt(0).toUpperCase() ? (
                      <div className={`border-bottom-primary text-primary`}>
                        <strong>
                          {school.resourceName.charAt(0).toUpperCase()}
                        </strong>
                      </div>
                    ) : null}
                    <a
                      className="d-block text-dark py-1"
                      href={`/schools/${school.slug}`}
                    >
                      {school.resourceName}
                    </a>
                  </div>
                ))}
              </div>
            ))
          ) : (
            <p>No School's Start with "{filter.toUpperCase()}"</p>
          )}
        </div>
        <div className="mt-4 d-flex flex-row align-items-center justify-content-center">
          {Math.ceil(pageCount / pageLimit) > 1 ? (
            <Pagination
              siblingPagesRange={0}
              currentPage={page}
              totalPages={Math.ceil(pageCount / pageLimit)}
              onChange={page => setPage(page)}
            />
          ) : null}
        </div>
      </div>
    </Fragment>
  );
};

export default SchoolsList;



// WEBPACK FOOTER //
// ./resources/assets/js/app/SchoolsList/index.js